// * ========================================================================
// * Animated slide of form from search icon
// * ========================================================================

'use strict';

import $ from 'jquery'; //npm package

var searchForm = (function() {
  const searchParentClass = '.navigation-search';
  const $formWrapper = $(searchParentClass + ' .js-target-form');
  const $triggerBtn = $(searchParentClass + ' .js-trigger-form');

  function init() {
    //Show search form on icon click.
    $triggerBtn.on('click', function(e) {
      if ($formWrapper.hasClass('visible')) {
        closeForm();
      } else {
        $formWrapper.addClass('visible');
        $formWrapper.find('input[type="text"]').first().trigger('focus');
        $('body').on('click', onBodyClick);
      }
    });
  }

  function closeForm () {
    $formWrapper.removeClass('visible');
    $('body').off('click', onBodyClick);
  }

  function onBodyClick (event) {
    //if clicked outside the wrapper, close form
    const clickedOther = $(event.target).closest(searchParentClass).length === 0;
    if(clickedOther) {
      closeForm();
    }
  }

  return {
    init: init
  };

})();

export default searchForm;
